import { FC, ReactNode } from 'react';
import { retrieveCmsProduct } from '../../../helper/cms';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { ShoppingProduct } from './ShoppingProduct';
import { AddonListActions, Product, ProductListActions } from '../../../types/webshop';
import { ShoppingAddon } from './ShoppingAddon';

interface ShoppingListProps {
  selectedProducts: Product[];
  selectedProductsActions: ProductListActions;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  setTotalPriceFetching: (value: boolean) => void;
  withEdit?: boolean;
  children?: ReactNode;
  selectedCategoryKey?: string;
  selectedSubcategoryKey?: string;
  cmsShopContent: ShopContent;
}

export const ShoppingList: FC<ShoppingListProps> = ({
  selectedProducts,
  selectedProductsActions,
  selectedAddons,
  selectedAddonsActions,
  setTotalPriceFetching,
  withEdit = false,
  children,
  selectedCategoryKey,
  selectedSubcategoryKey,
  cmsShopContent,
}) => {
  const hasProductsAndAddons = selectedProducts.length > 0 && selectedAddons.length > 0;

  return (
    <div className="flex flex-col">
      {hasProductsAndAddons && (
        <div className="pb-2 text-sm font-semibold text-text-dark">{cmsShopContent.shoppingCart.fromSami}</div>
      )}
      {selectedProducts.map((product: Product) => {
        if (!selectedCategoryKey || !selectedSubcategoryKey) {
          return null;
        }

        const cmsProduct = retrieveCmsProduct(
          product.code,
          cmsShopContent.categories,
          selectedCategoryKey,
          selectedSubcategoryKey,
        );
        if (!cmsProduct) {
          return null;
        }
        return (
          <ShoppingProduct
            key={product.code}
            price={Math.ceil(product.priceYearExclVat).toLocaleString('sv-SE')}
            product={cmsProduct}
            selectedProducts={selectedProducts}
            selectedProductsActions={selectedProductsActions}
            setTotalPriceFetching={setTotalPriceFetching}
            withEdit={withEdit}
            cmsShopContent={cmsShopContent}
          />
        );
      })}
      {hasProductsAndAddons && (
        <div className="pb-2 text-sm font-semibold text-text-dark">{cmsShopContent.shoppingCart.addons}</div>
      )}
      {selectedAddons.map((addon: Addon) => (
        <ShoppingAddon
          key={addon.code}
          addon={addon}
          selectedAddons={selectedAddons}
          selectedAddonsActions={selectedAddonsActions}
          withEdit={withEdit}
          cmsShopContent={cmsShopContent}
        />
      ))}
      {children}
    </div>
  );
};
